import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import axios from "axios";
import "./spellcheckstyle.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { styled, useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "./../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Pagination from "@mui/material/Pagination";
import MSelect from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { AppContext } from "../../../Context/Context";
import { Commonfun } from "./../Commonfun";
import { timezonechange } from "./../Commonfun";
import { timezoneval } from "./../Commonfun";
import { Breadcrumbs, Typography } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import rankedkeywordsicon from "../Asset/ESO/rankedkeywords.png";
import rankedkeywordsicon1 from "../Asset/ESO/rankedkeywords1.png";
import { datezonechange } from "../Commonfun";
import spellcheckersvg from "../Asset/esocardicon/spellchecker.svg";
import PdfandCsv from "../PdfandCsv";
import DatagridComp from "../DatagridComp";
import Commoncard from "../Commoncard";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Container, Grid, Card } from '@mui/material/';
import ScoreIcon from '@mui/icons-material/Score';



export default function CodeauditDetail() {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobDate, setjobDate] = useState("");
  const [spelldata, setSpelldata] = useState("");
  const [tablecardData, setTableCardData] = useState([]);
  const [faqData, setfaqData] = useState("2");
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [isDownloading, setIsDownloading] = useState(false);
  const [autoheightval, SetAutoheightval] = useState(true);
  const [totalSuggestions, setTotalSuggestions] = useState(0);
  const [checkD, setcheckD] = useState(false);
  const [successMsg, setsuccessMsg] = useState(false)
  const [values, setValues] = useState([]);
  const [apisuccessMsg, setapisuccessMsg] = useState();
  const [onPageError, SetonPageError] = useState("")
  const [tableLoading, setTableLoading] = useState(true);



  const navigate = useNavigate();
  let querystring = useParams();
  let spell_audit_id = querystring.detailid;
  let spell_job_id = querystring.jobid;

  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  useEffect(() => {
    callUserdataApi();
    faqdatafun();
  }, []);
  const callUserdataApi = async () => {
    setLoading(true);
    setTableLoading(true);
    const datavalue = await axios
      .get(
        `${process.env.REACT_APP_API_URL}spell_checker/v2/spell_check_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${spell_audit_id}&job_id=${spell_job_id}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        },
      )
      .catch((error) => {
        if (
          error?.response?.status == 599 ||
          error?.response?.status == 400 ||
          error?.response?.status == 500
        ) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error);
        } else if (error?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      });
    const date_dataval = datavalue?.data;
    setSpelldata(date_dataval);
    if (date_dataval?.job_date)
      setjobDate(moment(date_dataval?.job_date).format("MMMM DD,YYYY HH:mm"));
    else setjobDate(moment(date_dataval?.job_date).format("MMMM DD,YYYY"));
    const dataval = datavalue?.data?.table_data[0];
    const table_dataval = datavalue?.data?.table_data[0]?.result;
    const totalSuggestion = datavalue?.data?.table_data[0]?.sentences_with_suggestions_count;
    setTotalSuggestions(totalSuggestion);
    setCardData(dataval);

    if (table_dataval) {
      const newData = table_dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setTableCardData(newData);
      SetAutoheightval(false);
    } else {
      SetAutoheightval(true);
    }
    setTableLoading(false);
    setLoading(false);
  };
  const spellAddword = async (id) => {
    setLoading(true);
    const datavalue = await axios
      .get(
        `${process.env.REACT_APP_API_URL}spell_checker/v2/spell_check_changed_words?id=${spell_audit_id}&record_id=${id ? id : ""}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        },
      )
      .catch((error) => {
        if (
          error?.response?.status == 599 ||
          error?.response?.status == 400 ||
          error?.response?.status == 500
        ) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error);
        } else if (error?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      });
    const date_dataval = datavalue?.data;
    setValues(datavalue?.data?.changed_words)

    setLoading(false);
  };

  const spellCheckAlert = (id) => {
    spellAddword(id);
    setcheckD(true)
  }
  const columns = [

    {
      field: "original_sentence",
      headerName: "Existing Sentence",
      minWidth: 400,
      flex: 1,
      sortable: false,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: false,
      sortable: true,
      description: "Original sentence from the webpage that contains mistakes.",
    },
    // {
    //   field: "highlighted_sentence",
    //   headerName: "Suggested Sentence",
    //   minWidth: 500,
    //   flex: 1,
    //   sortable: false,
    //   headerAlign: "center",
    //   align: "center",
    //   disableClickEventBubbling: false,
    //   sortable: true,
    //   description: "The corrected version of the sentence with spelling and/or grammar adjustments.",
    //   renderCell: (tablecardData) => {
    //     const text = tablecardData.row.highlighted_sentence;
    //     return <div dangerouslySetInnerHTML={{ __html: text }} />;
    //   },
    // },

    {
      field: "highlighted_sentence",
      headerName: "Suggested Sentence",
      minWidth: 500,
      flex: 1,
      sortable: true,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: false,
      description: "The corrected version of the sentence with spelling and/or grammar adjustments.",
      renderCell: (tablecardData) => {
        const text = tablecardData.row.highlighted_sentence;
        return (
          <div
            style={{
              fontSize: "14px",
              color: "#2e2e2e",
              width: "500px"
            }}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        );
      },
    },

    {
      field: "modification_type",
      headerName: "Modification Type",
      minWidth: 350,
      flex: 1,
      sortable: false,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: false,
      sortable: true,
      description: "Indicates whether the suggestion was a spelling fix, grammar correction, or a complete rephrasing.",
      renderCell: (params) => params.value ?? "N/A",
    },
    {
      field: "View",
      headerName: "View",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      headerClassName: "hide_option",

      renderCell: (params) => {
        const handleClickinner = () => {
          const id = params.row.id; // Access the 'id' from the current row
          spellCheckAlert(id);
        };

        return (
          <button className="view-report-button" onClick={handleClickinner}>Add Word To Dictionary</button>
        );
      },
    },
  ];

  const rows = tablecardData ?? [];

  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }
  const pdfdown = async () => {
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}spell_checker/v2/spell_check_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${spell_audit_id}&is_format=pdf&timezone=${timezoneval()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        },
      );

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun(
          "SpellcheckerDetail",
          "pdf",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error(
          "Failed to fetch PDF:",
          response.status,
          response.statusText,
        );
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloading(false);
  };
  const csvdown = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}spell_checker/v2/spell_check_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&id=${spell_audit_id}&is_format=csv&timezone=${timezoneval()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/csv",
            Authorization: `${ApiToken}`,
          },
        },
      );

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun(
          "SpellcheckerDetail",
          "csv",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error(
          "Failed to fetch PDF:",
          response.status,
          response.statusText,
        );
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error("Error during PDF download:", error);
    }
    setLoading(false);
  };
  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=12`;

    try {
      const doaminsectiondatavalue = await axios
        .get(datavar, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/errorpages");
          }
        });
      if (doaminsectiondatavalue.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs);
      }
    } catch (err) { }
  };
  const handleClick = async (value) => {
    SetonPageError("")
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}settings/add_new_ignored_words/`,
        {
          user_domain_id: esodata.domaindata.value.header_selected,
          ignored_word: value,
        },
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
          return false;
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (response?.data?.message == "Word added successfully") {
        setsuccessMsg(true)
        setapisuccessMsg(response?.data?.message)
      }
    } catch (err) {
      setLoading(false);
      SetonPageError(err.response.data.error)
    }

    setcheckD(false)
  };
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1);
    } else {
      setfaqData(2);
    }
    setToggle((pre) => !pre);
  };
  const e = document.getElementById("root");
  e.addEventListener("click", function handleClick(event) {
    if (
      event.target.classList[0] === "cnt_hdr_blw_wrap" ||
      event.target.classList[0] === "header_wrap" ||
      event.target.classList[0] === "nav_key_txt" ||
      event.target.classList[0] === "cnt_hdr_top_wrap" ||
      event.target.classList[0] === "react-dropdown-select" ||
      event.target.classList[0] === "react-dropdown-select-content" ||
      event.target.classList[0] === "react-dropdown-select-item" ||
      event.target.classList[0] === "site_cnt_hdr_blw_wrap" ||
      event.target.classList[0] === "App" ||
      event.target.classList[0] === "cnt_audit_outer_wrap" ||
      event.target.classList[0] === "MuiDataGrid-columnHeaderTitleContainer" ||
      event.target.classList[0] === "MuiDataGrid-toolbarContainer" ||
      event.target.classList[0] === "MuiDataGrid-row" ||
      event.target.classList[0] === "MuiDataGrid-cell" ||
      event.target.classList[0] === "MuiDataGrid-cellContent" ||
      event.target.classList[0] === "header_inner_btm_wrap" ||
      event.target.classList[0] === "over_all_container" ||
      event.target.classList[0] === "input_domain_field" ||
      event.target.classList[0] === "react-dropdown-select-input" ||
      event.target.classList[0] === "data_table" ||
      event.target.classList[0] === "plagiarisam_missing_waring_wrap_databox" ||
      event.target.classList[0] === "MuiDataGrid-footerContainer" ||
      event.target.classList[0] === "ignore_button_active"
    ) {
      setfaqData(2);
      setToggle(false);
    }
  });


  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleModelPopUp = () => {

  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  return (
    <div
      className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Spell Checker Details</title>
      </Helmet>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={5}>
              <div>
                <h1 className="dashboard_header">
                  Detailed Spell Checker Report
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={7}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Content' },
                      { title: 'Spell Checker', activeColor: true, link: '/spell-checker' },
                      { title: 'Spell Checker Details', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span>
                  <a
                    target="_blank"
                    href={cardData?.link__url}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <span className="spanlink" style={{ flexDirection: "column" }}>
                      {cardData?.link__url}
                    </span>
                  </a>
                </span>
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            {/* <Grid item xs={12} md={3}>
              <div>
                <Card className="stat-card">
                  <Box className="stat-card-text">
                    <Typography variant="subtitle2" className="stat-card-title">
                      Number of Suggested Sentences
                    </Typography>
                    <Typography variant="h5" className="stat-card-value">
                      {totalSuggestions}
                    </Typography>
                  </Box>
                  <Box className="stat-card-icon">
                    <ScoreIcon className="stat-card-icon-inner" />
                  </Box>
                </Card>
                <Commoncard item={{
                  title: "Number of Suggested Sentences",
                  value: totalSuggestions,
                  iconSrc: spellcheckersvg,
                  altText: "Number of Suggested Sentences",
                  iconColor: 1,
                  bgColor: 1
                }}></Commoncard>
              </div>
            </Grid> */}
            <Grid item xs={12} md={6}>
              <div className="drop_down_button" >
                <Link to="/spell-checker-settings">
                  <button
                    title="Add Word to Dictionary"
                    className="btn_dashboard"
                  >
                    Add Word to Dictionary
                  </button>
                </Link>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}>
              <div className="common-card-container">
                <Grid item xs={12} sm={6} md={3}>
                  <Commoncard item={{
                    title: "Number of Suggested Sentences",
                    value: totalSuggestions,
                    iconSrc: spellcheckersvg,
                    altText: "Number of Suggested Sentences",
                    iconColor: 1,
                    bgColor: 1
                  }}></Commoncard>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0]}
                  tableLoading={tableLoading}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  customFilter={false}
                  DownloadShowFile={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2025 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand">eGrove Systems</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <div className="cnt_audit_outer_wrap">
        {toggle && (
          <Rightsidebar
            close={() => setToggle(false)}
            setToggle={setToggle}
            initialfaqDateval={initialfaqDateval}
          />
        )}



        {/* <DatagridComp
          columns={columns}
          rows={rows}
          autoheightval={autoheightval}
          datagridval={2}
          columnFreezeWidth={[0, 400]}
             tableLoading={tableLoading}
        /> */}
      </div>
      <Dialog
        open={checkD}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="box-dictionary" id="box-dictionary" style={{ width: "100% !important;" }}
      >
        <DialogTitle className="keyword-dialog-header">Add Word To Dictionary</DialogTitle>

        <div id="alert-dialog-slide-description" className="alert-dialog-box" style={{ overflow: "auto !important;" }}>
          {values?.map((value, index) => (
            <div className="alert-dialog-text">
              <div>
                <span style={{ overflowWrap: 'anywhere' }}>{value}</span>
              </div>
              <div style={{ width: " 50%;" }}><button className="runreportnew alert-dialog-box-button" onClick={() => handleClick(value)}>Add Word To Dictionary</button>  </div>
            </div>
          ))}
        </div>

        <DialogActions className="dialog-action-button alert-dialog-button">

          <Button
            onClick={() => {
              setcheckD(false);
              setValues([]);
            }}
          >Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={successMsg}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="domain-verify-alert"
      >
        <DialogTitle className="keyword-dialog-header">Add Word To Dictionary</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">

            <div
              style={{
                display: "flex",
                gap: "15px",
                lineHeight: "1px",
                width: "max-content",
                marginTop: "20px"
              }}
            >
              <p>{apisuccessMsg}</p>

            </div>

          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">

          <Button onClick={() => setsuccessMsg(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
